<template>
  <div :class="['filters-get', { message: !buttonStyle }]">
    <template v-if="buttonStyle">
      <ui-ui-button
        :resize="true"
        class="filter-btn"
        :disabled="!count"
        @click="getFilters"
      >
        <FiltersFiltersGetText
          :loading="loading"
          :count="count"
          prefix="Показать"
          :loader-type="!buttonStyle ? 'grey' : 'default'"
        />
      </ui-ui-button>
    </template>
    <template v-else>
      <FiltersFiltersGetText
        :loading="loading"
        :loader-type="!buttonStyle ? 'grey' : 'default'"
        :count="count"
        :prefix="wordEnd(count)"
      />
      <ui-ui-button
        v-if="!loading && count"
        class="filter-btn"
        :resize="true"
        @click="$emit('get-filters')"
      >
        Показать&nbsp;результаты
      </ui-ui-button>
    </template>
  </div>
</template>

<script setup lang="ts">
import numWord from '~/common/num-word.js';
const props = defineProps({
  loading: {
    type: Boolean,
    required: true,
  },
  count: {
    type: Number,
    required: true,
  },
  buttonStyle: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['get-filters']);
const wordEnd = (count: number) =>
  numWord(count, ['Найдено', 'Найден', 'Найдено', 'Найдено'], false);
const getFilters = () => {
  if (props.count) {
    emit('get-filters');
  }
};
</script>

<style scoped lang="scss">
.filters-get {
  position: fixed;
  top: unset;
  left: 0;
  bottom: 0;

  display: block;
  padding: 12px;
  margin-top: 0;
  width: 100%;

  background-color: $white;
  border-top: 1px solid $achromatic-hover;
  @include md-block {
    width: 320px;
  }
  &.message:before {
    display: none;
  }
  &:not(.message) {
    top: unset !important;
    left: 0 !important;
  }

  @include lg-block {
    position: relative;
    width: max-content;
    z-index: 11;
    min-width: 245px;

    &.message {
      position: absolute;
      padding: 20px;
      width: auto;
      height: min-content;
      margin-top: -32px;
      border-radius: 4px;
      background-color: $achromatic-card-bg;

      &:before {
        content: '';
        display: block;
        width: 9px;
        height: 9px;
        position: absolute;
        top: 27px;
        left: -6px;
        transform: rotate(45deg);
        background-color: $achromatic-card-bg;
      }

      .filter-btn {
        margin-top: 16px;
      }
    }
  }
}
</style>
